import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

export interface WalletState {
    wallet: any,
    transactionList: any[]
}
const initialState: WalletState = {
    wallet: null,
    transactionList: []
}
export const walletSlice = createSlice({
    name: 'wallet',
    initialState,
    reducers: {
        setWallet: (state, action: PayloadAction<any>) => {
            state.wallet = action.payload
        },
        setWalletTransactionList: (state, action: PayloadAction<any[]>) => {
            state.transactionList = action.payload
        }
    }
})

export const {
    setWallet,
    setWalletTransactionList
} = walletSlice.actions

export default walletSlice.reducer
